import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import $ from 'jquery';

class EditArticleType extends BasePage {

    loadOnConstructor(){
		this.getArticleTypeInterface = this.getArticleTypeInterface.bind(this);
		this.cancelButton = this.cancelButton.bind(this);
		this.saveButton = this.saveButton.bind(this);
		this.updateArticleTypeCallback = this.updateArticleTypeCallback.bind(this);
		this.newArticleTypeCallback = this.newArticleTypeCallback.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.parseResponse = this.parseResponse.bind(this);
		this.stringBackToStringFront = this.stringBackToStringFront.bind(this);

		const {article_type_id} = this.getUrlParams();
		if(article_type_id !== undefined){
			this.state = {action: 'modify'};
			this.getArticleTypeInterface(article_type_id);
		}else{
			this.state = {action: 'new'};
			this.getArticleTypeInterface();
		}
    }

    getArticleTypeInterface(articleTypeId){
		const api = this.getApi();
		api.getEditArticleTypeInterface(articleTypeId, this.parseResponse);
    }

    parseResponse(response){
		if(response.hasOwnProperty('auth') && response.auth === false){
			this.navigateTo('/login');
			return;
		}

		if(response.status === 'OK'){
			if(this.state.action === 'modify'){
				response.articleType.sign_date = this.stringBackToStringFront(response.articleType.sign_date);
				response.articleType.creation_date = this.stringBackToStringFront(response.articleType.creation_date);
				response.articleType.modification_date = this.stringBackToStringFront(response.articleType.modification_date);

				this.setState(prevState => {
					return {
						...prevState,
						articleType: response.articleType,
						i18n: response.i18n
					}
				});
			}else{
				this.setState(prevState => {
					return {
						...prevState,
						users: response.users,
						i18n: response.i18n
					}
				});
			}
		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}
	}

	stringBackToStringFront(originalStr){
		const objDate = new Date(originalStr);

		return objDate.getUTCFullYear() + "-" +
			("0" + (objDate.getUTCMonth()+1)).slice(-2) + "-" +
			("0" + objDate.getUTCDate()).slice(-2) + " " +
			("0" + objDate.getUTCHours()).slice(-2) + ":" +
			("0" + objDate.getUTCMinutes()).slice(-2) + ":" +
			("0" + objDate.getUTCSeconds()).slice(-2);
		}

		cancelButton(){
		this.goBack();
    }

    saveButton(){

		let failedValidators = {};

		if($('#name').val() === ''){
			failedValidators.name = this.getTrad('fillArticleTypeName');
		}

		if(Object.keys(failedValidators).length !== 0){
			let message = [];
			for (let m in failedValidators){
				message.push(failedValidators[m]);
			}
			this.props.setModalContent({
				title: 'Debe completar los datos obligatorios',
				body: message,
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}

		const api = this.getApi();

		if(this.state.action === 'modify'){
				api.updateArticleType(this.state.articleType,this.updateArticleTypeCallback);
		}else{
				api.newArticleType(this.state.articleType,this.newArticleTypeCallback);
		}
    }

    updateArticleTypeCallback(response){
	    if(response.status === 'OK'){
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: ['El tipo de articulo ha sido modificado satisfactoriamente.'],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			    ]
		    });

		    $("#exampleModal").modal('toggle');
	    }else{
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: [this.getTrad(response.message)],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true}
			    ]
		    });

		    $("#exampleModal").modal('toggle');

	    }
    }

    newArticleTypeCallback(response){
		if(response.status !== 'OK'){

			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
				]
			});

			$("#exampleModal").modal('toggle');

		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: ['El tipo de articulo ha sido creado satisfactoriamente.'],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
				]
			});

			$("#exampleModal").modal('toggle');
		}
    }

    handleChange(event) {

		let articleTypeMod = this.state.articleType?this.state.articleType:{};
		articleTypeMod[event.target.name] = event.target.value;

		this.setState(prevState => {
			return {
			...prevState,
			articleType: articleTypeMod
		}});
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.state.action === 'new'?this.getTrad('articleTypeInsertion'):this.getTrad('articleTypeEdition')}</h3>
                <div className="row mt-4">
			<div className="col-12">
			
			{(this.state.articleType || this.state.action === 'new')?
				<form>
				  
				  <div className="form-group">
				    <label htmlFor="name">Nombre</label>
				    <input type="text" className="form-control" id="name" name="name"
				    defaultValue={this.state.articleType?this.state.articleType.name:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="description">{this.getTrad('description')}</label>
				    <textarea type="text" className="form-control" id="description" name="description"
				    onChange={this.handleChange} defaultValue={this.state.articleType?this.state.articleType.description:''} />
				  </div>
				  
				  <div className="d-flex justify-content-between align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={this.saveButton}>Guardar</button>
					  <button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>
				</form>

			:<span>El tipo de articulo no existe</span>}

			</div>
                </div>

		<Modal />
            </div>
        );
    }

    cursorPointer = {
	cursor: 'pointer',
	width: '100%',
	background: '#CCC',
	padding:'3px',
	fontWeight: 'bold',
	textAlign: 'center'
    }
}

const mapStateToProps = state => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditArticleType)
